import { DEFAULT_COLOR_GRAY, DEFAULT_MARKDOWN_PLACEHOLDER } from '../constants'
import { basePropertiesSchema } from '../base-schema-properties'
import {
  textAlignSchemaField,
  textWeightSchema,
  textStyleSchema,
  textFontFamilySchema,
} from '../common'

export default {
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'Title',
  description: 'Block with markdown without background',
  type: 'object',
  required: ['text'],
  properties: {
    ...basePropertiesSchema,
    text: {
      title: 'Text',
      type: 'string',
      'ui:options': {
        placeholder: DEFAULT_MARKDOWN_PLACEHOLDER,
        type: 'textarea',
        rows: 3,
      },
    },
    textAlign: textAlignSchemaField,
    textColor: {
      title: 'Text Color',
      type: 'string',
      default: DEFAULT_COLOR_GRAY,
    },
    ...textFontFamilySchema,
    textWeight: textWeightSchema,
    textStyle: textStyleSchema,
  },
}
